<div id="demo-login-container" >
    <div id="login-box">
<!--        <div id="lb-title">{{ 'STRINGS.SIGN_IN' | translate }}</div>-->

        <div class="p-field">
            <label for="userName">{{'STRINGS.EMAIL' | translate}}</label>
            <input id="userName" type="text" pInputText [(ngModel)]="userName" (keydown)="onKeyDown($event)"/>
        </div>
        <div class="p-field">
            <label for="password">{{'STRINGS.PASSWORD' | translate}}</label>
            <input id="password" type="password" pInputText [(ngModel)]="password" (keydown)="onKeyDown($event)"/>
        </div>

        <div id="login-error">
            <span *ngIf="isInvalidLogin"> {{ 'SPECIAL_MSG.DEMO_LOGIN_INVALID' | translate}}</span>
        </div>

        <div id="lb-button-row">
            <p-button type="button" [label]="'STRINGS.SIGN_IN' | translate | uppercase" (onClick)="onSignIn()"></p-button>
        </div>

    </div>

    <toro-waiting-indicator *ngIf="isBusy" [isVisible]="isBusy" [blurBackground]="true"></toro-waiting-indicator>
</div>
